module.exports = __webpack_public_path__ + "static/img/scared_green.163f56d5.png";